import { HttpContextToken } from '@angular/common/http';

export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);

export const SUCCESS_CODES = new HttpContextToken<number[]>(() => [20000]);

export const IS_SUCCESS = new HttpContextToken<((res: any) => boolean) | null>(
  () => null,
);

export const SKIP_LOADING = new HttpContextToken<boolean>(() => false);

export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);
